export default [
  {
    name: "starTexture",
    type: "texture",
    path: "textures/5.png",
  },

  {
    name: "skyTexture",
    type: "exr",
    path: "textures/skyTexture.exr",
  },
  {
    name: "sealModel",
    type: "glbModel",
    path: "Seal._2.glb",
  },
  {
    name: "font",
    type: "font",
    path: "helvetiker_regular.typeface.json",
  },
  // {
  //   name: "timeScrubberMockup",
  //   type: "texture",
  //   path: "textures/timeScrubberMockup.png",
  // },
  {
    name: "sealData",
    type: "simulationData",
    path: "SealData.json",
  },
  // test31_FatiguedFiona-A.json
  // test31_FatiguedFiona-B.json
  // test31_FatiguedFiona-C.json
  // test31_FatiguedFiona-D.json
  // test31_FatiguedFiona-E.json
  // test33_HypoactiveHeidi-A.json
  // test33_HypoactiveHeidi-B.json
  // test33_HypoactiveHeidi-C.json
  // test33_HypoactiveHeidi-D.json
  // test33_HypoactiveHeidi-E.json
  // test35_JauntingJuliette-A.json
  // test35_JauntingJuliette-B.json
  // test35_JauntingJuliette-C.json
  // test35_JauntingJuliette-D.json
  // import all of these as SimulationData
  {
    name: "FatiguedFiona-A",
    type: "simulationData",
    path: "FatiguedFiona-A.csv",
  },
  {
    name: "FatiguedFiona-B",
    type: "simulationData",
    path: "FatiguedFiona-B.csv",
  },
  {
    name: "FatiguedFiona-C",
    type: "simulationData",
    path: "FatiguedFiona-C.csv",
  },
  {
    name: "FatiguedFiona-D",
    type: "simulationData",
    path: "FatiguedFiona-D.csv",
  },
  {
    name: "FatiguedFiona-E",
    type: "simulationData",
    path: "FatiguedFiona-E.csv",
  },
  {
    name: "FatiguedFiona-F",
    type: "simulationData",
    path: "FatiguedFiona-F.csv",
  },
  {
    name: "FatiguedFiona-G",
    type: "simulationData",
    path: "FatiguedFiona-G.csv",
  },
  {
    name: "FatiguedFiona-H",
    type: "simulationData",
    path: "FatiguedFiona-H.csv",
  },
  {
    name: "FatiguedFiona-I",
    type: "simulationData",
    path: "FatiguedFiona-I.csv",
  },
  {
    name: "HypoactiveHeidi-A",
    type: "simulationData",
    path: "HypoactiveHeidi-A.csv",
  },
  {
    name: "HypoactiveHeidi-B",
    type: "simulationData",
    path: "HypoactiveHeidi-B.csv",
  },
  {
    name: "HypoactiveHeidi-C",
    type: "simulationData",
    path: "HypoactiveHeidi-C.csv",
  },
  {
    name: "HypoactiveHeidi-D",
    type: "simulationData",
    path: "HypoactiveHeidi-D.csv",
  },
  {
    name: "HypoactiveHeidi-E",
    type: "simulationData",
    path: "HypoactiveHeidi-E.csv",
  },
  {
    name: "HypoactiveHeidi-F",
    type: "simulationData",
    path: "HypoactiveHeidi-F.csv",
  },
  {
    name: "HypoactiveHeidi-G",
    type: "simulationData",
    path: "HypoactiveHeidi-G.csv",
  },
  {
    name: "HypoactiveHeidi-H",
    type: "simulationData",
    path: "HypoactiveHeidi-H.csv",
  },
  {
    name: "HypoactiveHeidi-I",
    type: "simulationData",
    path: "HypoactiveHeidi-I.csv",
  },
  {
    name: "HypoactiveHeidi-J",
    type: "simulationData",
    path: "HypoactiveHeidi-J.csv",
  },
  {
    name: "JauntingJuliette-A",
    type: "simulationData",
    path: "JauntingJuliette-A.csv",
  },
  {
    name: "JauntingJuliette-B",
    type: "simulationData",
    path: "JauntingJuliette-B.csv",
  },
  {
    name: "JauntingJuliette-C",
    type: "simulationData",
    path: "JauntingJuliette-C.csv",
  },
  {
    name: "JauntingJuliette-D",
    type: "simulationData",
    path: "JauntingJuliette-D.csv",
  },
  {
    name: "JauntingJuliette-E",
    type: "simulationData",
    path: "JauntingJuliette-E.csv",
  },
  {
    name: "JauntingJuliette-F",
    type: "simulationData",
    path: "JauntingJuliette-F.csv",
  },
  {
    name: "JauntingJuliette-G",
    type: "simulationData",
    path: "JauntingJuliette-G.csv",
  },
];
